export function isAlphanumeric(value: string): boolean {
  return value.match(/[^a-z0-9]/gi) === null;
}

export function isLowerAlphanumeric(value: string): boolean {
  return value.match(/[^a-z0-9]/g) === null;
}
